import { GetStaticProps, NextPage } from "next";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import React, { FC } from "react";

import { Header } from "@baseComponents/Header";
import Footer from "@components/footer";
import { JustDescription } from "@components/just/description";
import { JustPreview } from "@components/just/justPreview";
import { CaseStudies } from "@components/landing/CaseStudies";
import { Menu } from "@components/menu";
import { AppContext, ThemeMode } from "@context/context";

const ThemedPage: FC = () => {
  const appContext = React.useContext(AppContext);
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>bluesBrackets - {t("just app")}</title>
        <meta name="description" content={t("just app short desc")} />
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <link
          rel="icon"
          type="image/svg+xml"
          href={
            appContext.systemTheme === ThemeMode.Light
              ? "favicon-light.svg"
              : "favicon-dark.svg"
          }
        />
        <link
          rel="icon"
          type="image/png"
          href={
            appContext.systemTheme === ThemeMode.Light
              ? "favicon-light.png"
              : "favicon-dark.png"
          }
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#1a1a1a" />
        <meta name="msapplication-TileColor" content="#1a1a1a" />
        <meta name="theme-color" content="#1a1a1a" />
      </Head>

      <Menu />

      <Header header={t("just app")} variant="caseStudy" />

      <JustPreview />

      <JustDescription />

      <CaseStudies
        header={t("landing.case_study.header")}
        subheader={t("landing.case_study.subheader")}
      />

      <Footer />
    </>
  );
};

const Just: NextPage = () => {
  return (
    <>
      <ThemedPage />
    </>
  );
};

export const getStaticProps: GetStaticProps = async context => {
  const locale = context.locale;

  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common"])),
    },
  };
};

export default Just;
